export default "__VITE_ASSET__Cl$GGrbr__"